import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-967c101c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "album link line" }
const _hoisted_2 = { class: "name c-primary" }
const _hoisted_3 = { class: "author c-thirdary" }

import Poster from '@/views/components/Poster.vue';

interface Props {
    album: MovieAlbum,
}

export default /*#__PURE__*/_defineComponent({
  props: {
    album: null
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", _hoisted_1, [
    _createVNode(Poster, {
      url: __props.album.thumb,
      theme: "album"
    }, null, 8, ["url"]),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(_toDisplayString(__props.album.title), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString(__props.album.speaker), 1)
  ]))
}
}

})